import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/promotorEncuestado";

// ─── Paginación por cursor (endpoint principal) ───────────────────────────────
/**
 * Obtener registros paginados por cursor.
 * @param {number} lastId    - Último id_temporal_rit de la página anterior (0 = primera página)
 * @param {number} pageSize  - Registros por página (default 30, máx 100)
 * @returns {Promise<{ data: Array, nextCursor: number|null, hasMore: boolean }>}
 * 
 * /**
 * Descarga TODOS los registros en bloques usando el cursor existente para excel
 * @param {function} onProgress - callback(porcentaje, filasCargadas, total)
 * @param {number} total        - total de registros (para calcular progreso)
 * @param {number} blockSize    - registros por bloque (default 500)
 */
 
/**
 * Funcion para exportar en excel
 */

export const obtenerTodosEncuestadosEnBloques = async (
  onProgress,
  total = 0,
  blockSize = 500
) => {
  const todos = [];
  let lastId  = 0;
  let hasMore = true;

  while (hasMore) {
    const resultado = await obtenerEncuestadosPaginado(lastId, blockSize);
    todos.push(...resultado.data);

    hasMore = resultado.hasMore;
    lastId  = resultado.nextCursor ?? 0;

    const porcentaje = total > 0
      ? Math.min(Math.round((todos.length / total) * 100), 99)
      : null;

    onProgress?.(porcentaje, todos.length, total);
  }

  return todos;
};


export const obtenerEncuestadosPaginado = async (lastId = 0, pageSize = 30) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}`, {
      params: { lastId, pageSize },
    });
    return response.data; // { data, nextCursor, hasMore }
  } catch (error) {
    console.error("Error obteniendo encuestados paginados:", error);
    throw error;
  }
};

export const obtenerTotalEncuestados = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/total`);
    return response.data.total; // número
  } catch (error) {
    console.error("Error obteniendo total:", error);
    throw error;
  }
};

// ─── Filtros (sin paginación, traen todo el filtro) ───────────────────────────

export const obtenerEncuestadosPorMunicipio = async (municipioId) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/municipio/${municipioId}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo encuestados por municipio:", error);
    throw error;
  }
};

export const obtenerEncuestadosPorDepartamento = async (departamentoId) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/departamento/${departamentoId}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo encuestados por departamento:", error);
    throw error;
  }
};

export const obtenerEncuestadoPorEncuesta = async (idEncuesta) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/encuesta/${idEncuesta}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo encuestado por id_encuesta:", error);
    throw error;
  }
};

// ─── Catálogos ────────────────────────────────────────────────────────────────

export const obtenerMunicipios = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/municipios`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo municipios:", error);
    throw error;
  }
};

export const obtenerDepartamentos = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/departamentos`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo departamentos:", error);
    throw error;
  }
};


